import BasePage from  './basePage';
import Slide from '../components/slide'
import Layer from "promokit-layer"

export default class Server1 extends BasePage{
  constructor(info){
    super(info);
    this.showMotion;
    this.slide = new Slide({
      ele:'#server1-slide',
      isArrow:true,
      isPagination:true,
      autoPlay: false,
      type:'nomal'
    })
    this.layer = new Layer();

    this.ele.querySelector('.btn-server1-layer').addEventListener('click', (e)=>{
      this.ele.dispatchEvent(new CustomEvent("pageEvent", {detail:{action:'showLayer'}}));
      this.layer.open(document.querySelector("#layer-server1").innerHTML);
      document.querySelector('.layer-server1 .close').addEventListener('click', (e)=>{

        this.layer.close();
      });
    });

    this.layer.on('layercloseend', ()=>{
      this.ele.dispatchEvent(new CustomEvent("pageEvent", {detail:{action:'hideLayer'}}));
    })

    this._motionSet();

  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true, onComplete: this._showCompleteContent, onCompleteParams: [this]});
    this.showMotion
      .fromTo(this.ele.querySelector('.chr-1'), 3, {autoAlpha:0, x:400}, {autoAlpha:1, x:0, ease: 'chr'}, '+=0.5')
      .fromTo(this.ele.querySelector('.chr-1>span'), 1, {autoAlpha:0.8}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')

      .addLabel('obj', '-=2.5')
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=0.3')
      .fromTo(this.ele.querySelector('.txt-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, 'obj+=0.6')
      .fromTo(this.ele.querySelector('.content-left'), 1, {autoAlpha:0, x:-100}, {autoAlpha:1, x:0, ease: Quart.easeOut}, 'obj+=0.8')
      .fromTo(this.ele.querySelector('.content-right'), 1, {autoAlpha:0, x:100}, {autoAlpha:1, x:0, ease: Quart.easeOut}, 'obj+=0.8')
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:0.8, y:0, ease: Quart.easeOut}, 'obj+=1.1')

  };
  show(size, dx){
    super.show(size, dx)
    this.showMotion.seek(0)
    this.showMotion.play();

    this.slide.select = 0;
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)
    this.showMotion.pause();
  }
  _showCompleteContent(thisv){
  }
}



// WEBPACK FOOTER //
// ./src/js/page/server1.js